export default __webpack_public_path__ + "static/media/plan_bateau.b0346e38.png";